/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Ranking
 */
export interface Ranking {
    /**
     * 
     * @type {string}
     * @memberof Ranking
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Ranking
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof Ranking
     */
    name: string;
    /**
     * 
     * @type {Date}
     * @memberof Ranking
     */
    latestDate: Date;
}

/**
 * Check if a given object implements the Ranking interface.
 */
export function instanceOfRanking(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "slug" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "latestDate" in value;

    return isInstance;
}

export function RankingFromJSON(json: any): Ranking {
    return RankingFromJSONTyped(json, false);
}

export function RankingFromJSONTyped(json: any, ignoreDiscriminator: boolean): Ranking {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'slug': json['slug'],
        'name': json['name'],
        'latestDate': (new Date(json['latest_date'])),
    };
}

export function RankingToJSON(value?: Ranking | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'slug': value.slug,
        'name': value.name,
        'latest_date': (value.latestDate.toISOString().substr(0,10)),
    };
}

